import React from "react";

function Previous({
  backgroundColor = "#f2f2f2",
  forgroundColor = "#7a7a7a",
  disabled,
}) {
  return (
    <svg
      width="28"
      height="28"
      aria-hidden="true"
      focusable="false"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity={`${disabled ? "0.5" : ""}`}>
        <rect width="28" height="28" rx="14" fill="#F2F2F2" />
        <path
          d="M15.5 19L10.5 14L15.5 9"
          stroke="#7A7A7A"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}

export default Previous;
